<template>
  <div>
    <Dialog
      :id="'dialogNuvemConectar'"
      ref="dialogNuvemConectar"
      :hide-header="false"
      :hideFooter="true"
      :modal="true"
      :tamanho="'xl'"
      :classModalBody="'mx-5 mx-xl-1 my-1'"
      :titulo="'Conectar'"
      @dialog-off="fechar()"
    >
      <div>
        <div>
          <h3 class="text-gray-800 text-center mb-8" v-if="false">
            <small>Nuvens associadas a sua conta</small>
          </h3>

          <!--begin::Item-->
          <div
            class="d-flex align-items-center mb-8"
            v-for="item in itens"
            :key="item._id"
            :item="item"
          >
            <span class="svg-icon svg-icon-2" v-if="item.token == 'local'">
              <i
                class="bi bi-pc-display-horizontal fs-2x gx-5 p-2 text-primary"
              ></i>
            </span>
            <span class="svg-icon svg-icon-2" v-if="item.token !== 'local'">
              <i class="bi bi-cloud fs-2hx gx-5 p-2 text-primary"></i>
            </span>
            <div class="flex-grow-1 ms-3">
              <span class="text-gray-800 text-hover-primary fw-bold fs-6">{{
                item.nuvem.nome
              }}</span>
              <span
                v-if="item.usuarioNuvem !== null"
                class="text-muted fw-semibold d-block"
                >{{ item.usuarioNuvem.nomeUsuario }}@{{
                  item.nuvem.alias
                }}</span
              >
            </div>
            <span
              class="badge badge-warning fs-8 fw-bold me-1"
              style="cursor: pointer"
              v-if="
                item.token !== 'local' &&
                (!item.isRoot || item.isRoot === false) 
              "
              @click="dialogRemover(item)"
              >Remover</span
            >
            <span
              class="badge badge-warning fs-8 fw-bold"
              style="cursor: pointer"
              v-if="item.token !== 'local' && !item.sessao && item.usuario"
              @click="loginNuvem()"
              >Reconectar</span
            >
            <span
              class="badge badge-success fs-8 fw-bold"
              style="cursor: pointer"
              @click="conectar(item)"
              v-if="item.sessao || !item.usuario"
              >Conectar</span
            >
          </div>
          <!--end:Item-->

          <div class="separator separator-dashed my-4"></div>

          <div class="text-center">
            <button
              type="button"
              class="btn btn-light-info"
              @click="loginNuvem"
            >
              Conectar outra nuvem
            </button>
          </div>
        </div>
      </div>
    </Dialog>
    <LoginDialog ref="loginDialog" @dialog-off="abrir()" />
    <DialogMensagem
      ref="dialogRemover"
      titulo="Remover "
      mensagem="Confirme caso deseje remover a conexão"
      classBody="mx-5 mx-xl-15 my-1 text-center"
      @confirmar="remover(true)"
      @cancelar="remover(false)"
    />
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";
import Dialog from "../components/ComponentDialog.vue";
import DialogMensagem from "../components/ComponentDialogMensagem.vue";
import { useAuthStore } from "@/stores/auth.js";
import { useStoreArvore } from "../stores/storeArvore.js";
import { useStoreUpload } from "../stores/storeUpload.js";

import LoginDialog from "./LoginDialog.vue";

export default {
  components: { Dialog, LoginDialog, DialogMensagem },
  props: {
    instancia: { type: String, default: "" }
  },

  setup() {
    const storeAuth = useAuthStore();
    const storeArvore = useStoreArvore();
    const storeUpload = useStoreUpload();

    return { storeAuth, storeArvore, storeUpload };
  },

  data() {
    return {
      timerFiltroTexto: null,
      itensTotal: 0,
      ordem: "nome_ASC",
      removerItem: null,
      itens: []
    };
  },

  mounted() {},

  methods: {
    abrir() {
      //* Define que consta uma dialog aberta
      this.storeArvore.dialogAberta = true;

      this.$emit("dialog-on");
      this.carregarItens();
      this.$refs.dialogNuvemConectar.abrir();
    },
    fechar() {
      //* Define que consta uma dialog aberta
      this.storeArvore.dialogAberta = false;

      this.$refs.dialogNuvemConectar.fechar();
      this.$emit("dialog-off");
    },
    async inserirItens() {
      if (this.dialog) {
        this.$emit("dialog-off");
      }
    },
    async carregarItens() {
      let filtros = "";

      //* Limpa os itens
      this.itens = [];

      filtros += "?_limit=" + 500;
      filtros += "&_ordem=" + this.ordem;

      //* Verifica se existe token da conta principal salvo
      let ckdRoot = localStorage.getItem("ckdRoot");

      if(ckdRoot == null || ckdRoot === "" || ckdRoot === "undefined")
      {
        ckdRoot = this.storeAuth.sessao.key;
      }
      
      if (this.$funcoes.appTipo() == "desktop") {
        this.itens.push({
          _id: "local",
          token: "local",
          nuvem: { nome: "Árvore Local" },
          usuarioNuvem: null
        });
      }

      const responseSessao = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/sessao/refresh",
        ckdRoot
      );

      let sessaoPrincipal;

      if (responseSessao.data && responseSessao.data.erro === false) {
          sessaoPrincipal = responseSessao.data.item;
      }

      
      //* Adiciona a conta principal (root) apenas se conseguiu carregar ou se não está em conta secundária
      if (sessaoPrincipal) {
        this.itens.push({
          _id: sessaoPrincipal.usuario.nuvem._id,
          token: ckdRoot,
          nuvem: sessaoPrincipal.usuario.nuvem,
          usuarioNuvem: sessaoPrincipal.usuario,
          isRoot: true,
          tokenRoot: ckdRoot
        });
      }

      //* Carrega as minhas nuvens
      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/usuario/minhas-nuvens" + filtros,
        ckdRoot
      );
      //api.valid(response.data, this.$router);

      //* Adiciona as outras nuvens conectadas, filtrando duplicatas (root e atual)
      if (response.data.erro == false && response.data.itens.length > 0) {
        const idsExistentes = new Set(this.itens.map(i => i._id));
        const itensNovos = response.data.itens.filter(i => !idsExistentes.has(i._id));
        this.itens.push(...itensNovos);
      }

      this.itensTotal = response.data.total;

    },
    async conectar(item) {

      //* Define como padrao que esta tratando uma arvore remota
      var tipo = "remoto";

      //* Limpar filas
      this.storeUpload.fila = {};
      this.storeUpload.arquivos = {};

      //* Verifica se esta definindo a instancia
      if (this.instancia !== "") {
        this.storeAuth.token[this.instancia] = "";
        this.storeAuth.nuvem[this.instancia] = null;
      }
      
      //* Verifica se esta conectando nos diretorios locais
      if (item.token == "local") {
        //* Altera o tipo para local
        tipo = "local";
      } else {
        //* Verifica se é instancia vazia (login principal)
        if (this.instancia === "") {
          //* Verifica se está mudando para uma nuvem diferente
          if (item.token !== this.storeAuth.sessao.key) {

            //* Define o novo token de acesso
            localStorage.setItem("ckd", item.token);

            //* Valida se o item é o item root
            if(item.isRoot){
              localStorage.removeItem("ckdRoot");
            }else{
              localStorage.setItem("ckdRoot", this.itens.find(i => i.isRoot)?.token || "");
            }

            //* Carrega os dados da sessao
            const responseSessao = await api.get(
              window._env_.VUE_APP_URL_API + "/admin/sessao/refresh",
              item.token
            );

            //* Coloca no localstorage
            if (responseSessao.data && responseSessao.data.erro === false) {
                localStorage.setItem("ckdCch", JSON.stringify(responseSessao.data.item));
            }
            
            //* Recarrega a página para aplicar todas as mudanças
            window.location.reload();
            return;
            
          } else {
            //* Já está na conta correta, fecha a dialog
            this.fechar();
            return;
          }
        } else {
          //* Verifica se conectou na mesma sessao do usuario conectado
          if (item.token !== this.storeAuth.sessao.key) {
            //* Define o token da nuvem conectada
            this.storeAuth.token[this.instancia] = item.token;

            //* Define os dados da nuvem
            this.storeAuth.nuvem[this.instancia] = item.nuvem;

            //* Armazena o usuario autenticado da nuvem
            this.storeAuth.nuvem[this.instancia].usuarioNuvem = item.usuarioNuvem;
          }
        }
      }

      //* Verifica se esta definindo a instancia
      if (this.instancia !== "") {
        //* Recarrega a arvore
        this.storeArvore.recarregarInstancia(this.instancia, tipo);

        //* Fecha a dialog
        this.fechar();
      }
      
    },
    dialogRemover(item) {
      //* Armazena o item que sera removido
      this.removerItem = item;

      //* Abre a dialog de remover
      this.$refs.dialogNuvemConectar.fechar();
      this.$refs.dialogRemover.abrir();
    },
    async remover(confirmar) {
      //* Verifica se confirmou a remoção
      if (confirmar) {
        //* Pega o token root se estiver em conta secundária
        let ckdRoot = localStorage.getItem("ckdRoot");
        
        //* Valida e usa fallback se necessário
        if (!ckdRoot || ckdRoot === "" || ckdRoot === "undefined") {
          ckdRoot = this.storeAuth.sessao?.token || localStorage.getItem("ckd");
        }

        //* Remove a nuvem associada usando o token root
        await api.delete(
          window._env_.VUE_APP_URL_API +
            "/admin/usuario/minhas-nuvens?tokenConexao=" +
            encodeURIComponent(this.removerItem.token),
          ckdRoot
        );
        this.carregarItens();
      }

      //* Limpa o item que sera removido
      this.removerItem = null;

      //* Abre a dialog de remover
      this.$refs.dialogRemover.fechar();
      this.$refs.dialogNuvemConectar.abrir();
    },
    loginNuvem() {
      //* Fecha a janela de nuvens
      this.$refs.dialogNuvemConectar.fechar();

      //* Abre a dialog de login
      this.$refs.loginDialog.abrir();
    },

    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      const obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.carregarItens();
      }, 300);
    }
  }
};
</script>

<style></style>
